import { FETCH_NON_CONFORMITY, FETCH_NON_CONFORMITY_LIST } from "constants/ActionTypes";

const INITIAL_STATE = {
  nonConformityList: [],
  nonConformity: {},
};

const NonConformityReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_NON_CONFORMITY_LIST: {
      return {
        ...state,
        nonConformityList: action.payload,
      };
    }
    case FETCH_NON_CONFORMITY: {
      return {
        ...state,
        nonConformity: action.payload,
      };
    }

    default:
      return state;
  }
};

export default NonConformityReducer;
